export default __webpack_public_path__ + "static/media/visa.7a8faac7.svg";